module.exports = __webpack_public_path__ + "15f336a3247686c7e925de3aad2cbc3e.png";